import {IcnBankFilled, IcnFingerprint, IcnQrCode} from "../../assets/icons";
import {AvailableBalance} from "../../utils/creditService";

import {cModalFormViewButton} from "../../utils";

import ModalFormWrapper from "../common/ModalFormWrapper";
import ModalFormViewButton from "../common/ModalFormViewButton";

interface HomeRepayCreditModalViewProps {
  onCloseModal: () => void;
  onClickStablecoin: () => void;
  onClickRamp: () => void;
  creditLine: AvailableBalance;
}

const ModalFormViewButtonList = (
  {
    onClickStablecoin,
    onClickRamp,
  }: {
    onClickStablecoin: () => void;
    onClickRamp: () => void;
  }): cModalFormViewButton[] => [
  {
    icon: <IcnQrCode />,
    title: "Pay with stablecoin",
    description: "Transfer from a crypto wallet",
    onClick: onClickStablecoin,
    enabled: true,
  },
  {
    icon: <IcnBankFilled />,
    title: "Repay through on-ramp",
    description: "Transfer funds from a fiat payment method",
    onClick: onClickRamp,
    enabled: false,
  },
];

function HomeRepayCreditModalView (
  {
    onCloseModal,
    onClickStablecoin,
    onClickRamp
  }:HomeRepayCreditModalViewProps) {

  const buttons = ModalFormViewButtonList({ onClickStablecoin, onClickRamp });

  return (
    <>
      <ModalFormWrapper
        headerTitle="Select a method to repay"
        hideBackButton
        onCloseModal={onCloseModal}
      >

        {buttons.map((btn, btnIdx) => (
          <ModalFormViewButton
            key={btnIdx}
            icon={btn.icon}
            title={btn.title}
            description={btn.description}
            onClick={btn.onClick}
            enabled={btn.enabled}
          />
        ))}

      </ModalFormWrapper>

      <div className="c-modal-footer">
        <small>
            <i><IcnFingerprint/></i>
            All transactions on Liquid Credit protected by enterprise-grade security.
            </small>
      </div>

    </>
  );
}

export default HomeRepayCreditModalView;